function PlusThin({color = 'black'}: {color?: string}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M8 3.83203C8.04401 3.83212 8.08602 3.84978 8.11719 3.88086C8.14844 3.91212 8.16602 3.95482 8.16602 3.99902V7.83203H12C12.044 7.83212 12.086 7.84978 12.1172 7.88086C12.1484 7.91211 12.166 7.95482 12.166 7.99902C12.1659 8.04311 12.1484 8.08503 12.1172 8.11621C12.086 8.14739 12.0441 8.16495 12 8.16504H8.16602V11.999C8.16593 12.0431 8.14837 12.085 8.11719 12.1162C8.08601 12.1474 8.04409 12.165 8 12.165C7.9558 12.165 7.91309 12.1475 7.88184 12.1162C7.85076 12.085 7.83309 12.043 7.83301 11.999V8.16504H4C3.9558 8.16504 3.91309 8.14747 3.88184 8.11621C3.85076 8.08505 3.83309 8.04303 3.83301 7.99902C3.83301 7.95482 3.85058 7.91212 3.88184 7.88086C3.91309 7.8496 3.9558 7.83203 4 7.83203H7.83301V3.99902C7.83301 3.95482 7.85058 3.91212 7.88184 3.88086C7.91309 3.8496 7.9558 3.83203 8 3.83203Z"
                fill={color}
                stroke={color}
            />
        </svg>
    );
}

export default PlusThin;
